import Axios from 'axios'

import {
  StencilApiHeaders,
  XsrfResilient,
  areAllShipmentsAssigned,
} from '@/services/Helpers'

import {
  standardizeOrderFromResponse,
  MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing,
} from '@/services/Standardizers'

import { isValidAddress } from '@/helpers/'

import { log, error } from '@/services/Log'
//---------------------------------------------------------------
import { recoverAvailableShippingOptions } from './index'

import {
  getOrder,
} from '@/services/FramedCheckout/orderServices'

// Recovers the original oder consignments for a new cart generated after a bigcAPI interaction.
const recoverShippingOptions = XsrfResilient(async ({
  order, newCart, newOrder: newOrderInput,
}) => {
  // the shipment option ID changes in bigcommerce so we need to update the consignment
  log('recoverShippingOptions START', { order, newCart, newOrderInput })
  const headers = StencilApiHeaders('put')
  let newOrder = newOrderInput ? { ...newOrderInput } : await getOrder({ cart: newCart })
  const consignmentIds = newOrder.shipments.map(({ id }) => id)
  for (let i = 0; i < consignmentIds.length; i++) {
    // Queueing shippingOptionId assignments due to its interference in other shipments
    const consignment = newOrder.shipments.find(({ id }) => id === consignmentIds[i])
    const {
      id: shipmentId,
      selectedShippingOption: currentShippingOption,
      shippingAddress,
    } = consignment
    let { availableShippingOptions } = consignment
    if (!availableShippingOptions.length && isValidAddress(shippingAddress)) {
      const recoveredOptions = await recoverAvailableShippingOptions({
        order: newOrder, shipmentId,
      })
      if (recoveredOptions?.success) {
        const shipment = recoveredOptions?.shipment
        availableShippingOptions = shipment?.availableShippingOptions
        newOrder = recoveredOptions?.newOrder
      } else {
        error('recoverShippingOptions FAILED recoverAvailableShippingOptions FAILED')
      }
    }
    const expectedShippingOption = order?.shipments?.find(
      ({ id }) => id === shipmentId,
    )?.selectedShippingOption
    // Check if the shippingOption description is different.
    // Note on shippingOptions:
    // {id,type,description} =
    // (id = volatile, type = constant across options, We are forced to use the description !)
    if (
      expectedShippingOption
            && expectedShippingOption?.description !== currentShippingOption?.description
    ) {
      const shippingOptionId = (
        availableShippingOptions?.find(({ description }) => (
          description === expectedShippingOption.description
        ))?.id
        || availableShippingOptions?.[0]
      )
      if (shippingOptionId) {
        // Updates an existing consignment - https://developer.bigcommerce.com/api-reference/storefront/checkouts/checkout-consignments/checkoutsconsignmentsbycheckoutidandconsignmentidput
        // line item IDs or the shipping option ID can be updated using this endpoint.
        const { status, data } = (await Axios.put(`/api/storefront/checkouts/${newOrder?.cart?.id}/consignments/${shipmentId}?include=consignments.availableShippingOptions`, JSON.stringify({ shippingOptionId }), { headers }))
        if (status !== 200) {
          return { success: false }
        } if (data) {
          // update newOrder with the response data.
          // other consignments' shipping options IDs change on every request
          newOrder = standardizeOrderFromResponse({ order, bigcResponse: data })
        }
      }
    } else if (!currentShippingOption && expectedShippingOption) {
      newOrder = await getOrder({ cart: newCart })
      log('recoverShippingOptions END', { success: false, newOrder, areAllShipmentsAssigned: areAllShipmentsAssigned(newOrder) })
      return { success: false, newOrder }
    }
  }
  await MUTATIVELY_appendArrivalInformationToOrderCartAfterStandardizing({ order: newOrder })
  log('recoverShippingOptions END', { success: true, newOrder, areAllShipmentsAssigned: areAllShipmentsAssigned(newOrder) })
  return { success: true, newOrder }
})

export default recoverShippingOptions
